import axios from "axios";
import {
  clearLoggedInUserInvalidCredential,
  clearLoggedInUserInvalidCredentialTokenExpired,
} from "app/utils/utils";
// Removing toast import as axios will no longer handle toasts
// import { toast } from "react-toastify";

export const domainUrl = "https://timetango.in";
// export const baseURL = "http://129.154.237.106:8000";
export const baseURL = "https://timetango.in/api";
// export const baseURL = "https://dev.timetango.in/devapi";
// export const baseURL = "http://192.168.1.15:8080";
// export const baseURL = "https://sahbazar.in/api";

// Create Axios instances
export const axiosApiInstanceAuth = axios.create({ baseURL });
export const axiosApiInstance = axios.create({ baseURL });
export const axiosMultipart = axios.create({ baseURL });

// Removing error state and related functions as axios will not handle toasts
// const errorState = {
//   lastError: null,
//   lastErrorTime: 0,
//   sessionExpiredShown: false,
//   isLoggingOut: false,
//   toastCooldown: 3000, // 3 seconds cooldow
// };

// Removing resetErrorState as it's not needed if axios doesn't handle toasts
// export const resetErrorState = () => {
//   errorState.lastError = null;
//   errorState.lastErrorTime = 0;
//   errorState.sessionExpiredShown = false;
//   errorState.isLoggingOut = false;
// };

// Request interceptor
const requestInterceptor = async (config) => {
  try {
    const token = localStorage.getItem("tokan");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  } catch (err) {
    console.error("Request interceptor failed:", err);
    return Promise.reject(err);
  }
};

// Response interceptor
const responseInterceptor = (response) => response;

// Removing showToast and handleSessionExpiration as axios will not handle toasts
// const showToast = (message, toastId) => {
//   const currentTime = Date.now();
//
//   // Check if this is a duplicate message within cooldown period
//   if (
//     errorState.lastError === message &&
//     (currentTime - errorState.lastErrorTime) < errorState.toastCooldown
//   ) {
//     console.log("Duplicate error message within cooldown:", message); // Log for debugging
//     return;
//   }
//
//   // Update error state
//   errorState.lastError = message;
//   errorState.lastErrorTime = currentTime;
//
//   // Show toast
//   toast.error(message, {
//     position: toast.POSITION.TOP_RIGHT,
//     toastId,
//   });
// };

// Removing handleSessionExpiration as axios will not handle toasts directly
// const handleSessionExpiration = (errorMessage) => {
//   if (!errorState.sessionExpiredShown) {
//     errorState.sessionExpiredShown = true;
//     errorState.isLoggingOut = true;
//
//     showToast(errorMessage || "Session expired. Please log in again.", "sessionExpired");
//
//     setTimeout(() => {
//       clearLoggedInUserInvalidCredentialTokenExpired();
//       errorState.isLoggingOut = false;
//     }, 1000);
//   }
// };

// Main error interceptor - now only logs and rejects errors
export const errorInterceptor = (error) => {
  // Log the error for debugging
  console.error("API Error Intercepted:", error);

  // Re-throw the error so components can catch and handle it
  return Promise.reject(error);
};

// Attach interceptors to all axios instances
[axiosApiInstanceAuth, axiosApiInstance, axiosMultipart].forEach((instance) => {
  instance.interceptors.request.use(requestInterceptor, Promise.reject);
  instance.interceptors.response.use(responseInterceptor, errorInterceptor);
});

// Export default instance
export default axiosApiInstance;
